import axios from "axios";


const BASE_URL = process.env.REACT_APP_BASE_URI;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true, // ✅ Automatically send cookies
});



export default api;